import i18n from "i18next";
import moment from "moment";

export function isEmailValid(email: string) {
    const EMAIL_VALIDATION_REGEX = /\S+@\S+\.\S+/;
    return EMAIL_VALIDATION_REGEX.test(email);
}

export function toLowerCase(object: any): any {
    if (Array.isArray(object)) {
        return object.map(toLowerCase);
        // eslint-disable-next-line
    } else if (object !== null && typeof object === "object") {
        return Object.fromEntries(
            Object.entries(object).map(([key, value]: any) => [
                key,
                toLowerCase(value),
            ])
        );
    } else if (typeof object === "string") {
        return object.toLowerCase();
    } else {
        return object;
    }
}

export function truncateString(string: string, maxLength: number): string {
    return string?.length > maxLength
        ? `${string?.slice(0, maxLength)}...`
        : string;
}

export function getLastXDaysInTimestamp(lastXDays: number): string[] {
    const array: number[] = [];

    for (let i = 0; i < lastXDays; i += 1) {
        array.push(i);
    }

    return array
        .map((day: number) => {
            return Math.trunc(
                moment(
                    new Date(
                        moment().subtract(1, "days").unix() * 1000
                    ).getTime() -
                        86400000 * day
                ).unix()
            );
        })
        .sort()
        .map(String);
}

export function getAdvancedSeeMorePeriod(
    period: string,
    advancedDate: {
        startDate: string;
        endDate: string;
    }
) {
    if (advancedDate.startDate !== "" && advancedDate.endDate !== "") {
        return {
            startDate: advancedDate.startDate,
            endDate: advancedDate.endDate,
        };
    }

    if (period === i18n.t("Current week")) {
        return {
            startDate: String(moment().startOf("week").unix()),
            endDate: String(moment().endOf("week").unix()),
        };
    }

    if (period === i18n.t("Current month")) {
        return {
            startDate: String(moment().startOf("month").unix()),
            endDate: String(moment().endOf("month").unix()),
        };
    }

    if (period === i18n.t("Current year")) {
        return {
            startDate: String(moment().startOf("year").unix()),
            endDate: String(moment().endOf("year").unix()),
        };
    }

    if (period === i18n.t("Last Month")) {
        return {
            startDate: String(
                moment().subtract(1, "month").startOf("month").unix()
            ),
            endDate: String(
                moment().subtract(1, "month").endOf("month").unix()
            ),
        };
    }

    if (period === i18n.t("The last 7 days")) {
        const timestamps = getLastXDaysInTimestamp(7);
        return {
            startDate: timestamps[0],
            endDate: timestamps[6],
        };
    }

    if (period === i18n.t("Last Week")) {
        return {
            startDate: moment().subtract(1, "week").startOf("week").toDate(),
            endDate: moment().subtract(1, "week").endOf("week").toDate(),
        };
    }

    if (period === i18n.t("The last 30 days")) {
        const timestamps = getLastXDaysInTimestamp(30);
        return {
            startDate: timestamps[0],
            endDate: timestamps[29],
        };
    }
    if (period === i18n.t("Today")) {
        const todayStart = moment().startOf("day").unix();
        const todayEnd = moment().endOf("day").unix();

        return {
            startDate: todayStart,
            endDate: todayEnd,
        };
    }

    // Fallback return if none of the conditions match
    return {
        startDate: "",
        endDate: "",
    };
}

export function getAdvancedPeriodStringParam(
    period: any,
    advancedDate: { startDate: string; endDate: string }
): string {
    console.log("period : ",period )
    if (period.date === i18n.t("Today")) {
        return "today";
    }

    if (advancedDate.startDate !== "" && advancedDate.endDate !== "") {
        return `start_date=${advancedDate.startDate}&end_date=${advancedDate.endDate}`;
    }

    if (period.date === i18n.t("Current week")) {
        return "week";
    }
    if (period.date === i18n.t("Current Month")) {
        return "month";
    }
    if (period.date === i18n.t("This Year")) {
        console.log("111")
        return "year";
    }

    if (period.date === i18n.t("The last 7 days")) {
        return "last_seven_days";
    }

    if (period.date === i18n.t("The last 30 days")) {
        return "last_thirty_days";
    }
    
   if (period.date ===  i18n.t("Last Month")) {
        return "last_thirty_days";
    }

    return "month";
}

export async function downloadStoreReportCsv(
    fileName: string,
    merchentAccount: string,
    isFacture: boolean,
    storeReference?: string
) {
    try {
        const baseUrl = process.env.REACT_APP_ADMIN_ACCESS;
        const endpoint = isFacture
            ? "downloadFacture"
            : "downloadStoreReportCsv";

        const params = new URLSearchParams({
            merchentAccount,
            ...(isFacture
                ? {
                      factureFileName: fileName,
                      storeReference: storeReference ?? "",
                  }
                : { repportFileName: fileName }),
        });

        const urlDownload = `${baseUrl}/${endpoint}?${params.toString()}`;

        const response = await fetch(urlDownload);
        if (!response.ok) {
            throw new Error("Failed to download file");
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const extension = isFacture ? "pdf" : "csv";

        const link = Object.assign(document.createElement("a"), {
            href: url,
            download: `${fileName}.${extension}`,
        });

        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        return true;
    } catch (error) {
        console.error("Error in downloadStoreReportCsv : ", error);
    }
}
